<template>
  <div class="apply">

    <div class="apply-top">
      <van-nav-bar title="数据看板">
        <template #left>
          <van-icon name="arrow-left" size="24" @click="goBack"/>
        </template>
        <template #right>
          <van-button hairline icon="down" plain size="small" type="primary"
                      @click="download">下载表格
          </van-button>
        </template>
      </van-nav-bar>
      <van-dropdown-menu>
        <van-dropdown-item :title="cascadeText" ref="cascadeRef">
          <van-cascader
              v-model="cascadeValue"
              :options="cascadeOption"
              @finish="onCascadeConfirm"
              :show-header="false"
              :swipeable="false"
          />
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>

    <div class="menu-detail">
      <div class="menu-list">
        <van-sidebar v-model="active">
          <van-sidebar-item
              :title="item['text']"
              v-for="(item, index) in menuList"
              :key="index"
              @click="handleMenuList(index)"/>
        </van-sidebar>
      </div>

      <div class="apply-body">
        <van-skeleton :loading="loading" :row="3" :style="{ paddingTop: '16px' }">

          <van-empty v-if="dataList0.length < 1" description="暂无数据" />

          <el-table :data="dataList0" stripe border height="600" style="width: 100%" v-if="active === 0 && dataList0.length > 0">
            <el-table-column prop="company" label="公司" sortable fixed width="85" />
            <el-table-column prop="jobName" label="职位" sortable fixed />
            <el-table-column prop="needNum" label="招聘数" sortable />
            <el-table-column prop="submitNum" label="投递数" sortable />
            <el-table-column prop="firstNum" label="初筛数" sortable />
            <el-table-column prop="passNum" label="通过数" sortable />
            <el-table-column prop="passRate" label="通过率（%）" sortable />
          </el-table>

          <el-table :data="dataList0" stripe border height="600" style="width: 100%" v-if="active === 1 && dataList0.length > 0">
            <el-table-column prop="company" label="公司" sortable fixed width="85" />
            <el-table-column prop="jobName" label="职位" sortable fixed />
            <el-table-column prop="userName" label="姓名" sortable />
            <el-table-column prop="qualification" label="学历" sortable />
            <el-table-column prop="major" label="专业" sortable />
            <el-table-column prop="school" label="毕业院校" sortable />
            <el-table-column prop="interviewTime" label="面试时间" sortable />
          </el-table>

          <el-table :data="dataList0" stripe border height="600" style="width: 100%" v-if="active === 2 && dataList0.length > 0">
            <el-table-column prop="company" label="公司" sortable fixed width="85" />
            <el-table-column prop="jobName" label="职位" sortable fixed />
            <el-table-column prop="totalNum" label="浏览量" sortable />
            <el-table-column prop="ipNum" label="独立访客数" sortable />
          </el-table>

          <el-table :data="dataList0" stripe border height="600" style="width: 100%" v-if="active === 3 && dataList0.length > 0">
            <el-table-column prop="company" label="公司" sortable fixed width="85" />
            <el-table-column prop="jobName" label="职位" sortable fixed />
            <el-table-column prop="submitNum" label="投递数" sortable />
            <el-table-column prop="firstNum" label="初筛数" sortable />
            <el-table-column prop="interviewNum" label="面试数" sortable />
            <el-table-column prop="passNum" label="通过数" sortable />
            <el-table-column prop="firstRate" label="投递→初筛（%）" sortable />
            <el-table-column prop="interviewRate" label="初筛→面试（%）" sortable />
            <el-table-column prop="successRate" label="面试→通过（%）" sortable />
          </el-table>

        </van-skeleton>
      </div>
    </div>

  </div>

</template>

<script>
import {getCompanyJobOption, getEmployProgress, getPassList, getReadJob} from "@/api";

export default {
  name: "DataBoard",
  data() {
    return {
      loading: true,

      active: 0,
      menuList: [
        {text: '招聘进度', value: 0},
        {text: '面试通过人员来源', value: 1},
        {text: '职位浏览量明细', value: 2},
        {text: '面试流程放弃率', value: 3},
      ],

      companyId: '',
      jobId: '',

      cascadeText: '全部公司 · 全部职位',
      cascadeValue: '',
      cascadeOption: [
        { text: '全部公司', value: '', children: [
            { text: '全部职位', value: '' }
          ] },
      ],

      dataList0: [],
    }
  },
  mounted() {
    this.loading = true;

    getCompanyJobOption().then((res) => {
      if (res.code === 200) {
        for (let data of res.data) {
          this.cascadeOption.push(data);
        }
      }
    });

    getEmployProgress().then((res) => {
      if (res.code === 200) {
        this.dataList0 = res.data;
        this.loading = false;
      }
    });
  },
  methods: {
    goBack() {
      window.history.back();
    },
    download() {

    },
    handleMenuList(index) {
      this.active = index;
      this.getTableData('');
    },
    onCascadeConfirm(option) {
      this.loading = true;
      this.companyId = option['selectedOptions'][0]['value'];
      this.jobId = option['value'];
      let companyName = option['selectedOptions'][0]['text'];
      let jobName = option['selectedOptions'][1]['text'];
      if (this.companyId === '0' && this.jobId === '0') {
        this.cascadeText = '全部职位';
      } else {
        this.cascadeText = companyName + ' · ' + jobName;
      }
      this.$refs.cascadeRef.toggle();

      let obj = 'companyId=' + this.companyId + '&jobId=' + this.jobId;
      this.getTableData(obj);
    },

    getTableData(obj) {
      this.loading = true;
      this.dataList0 = [];
      if (this.active === 0 || this.active === 3) {
        getEmployProgress(obj).then((res) => {
          if (res.code === 200) {
            this.dataList0 = res.data;
            this.loading = false;
          }
        });
      } else if (this.active === 1) {
        getPassList(obj).then((res) => {
          if (res.code === 200) {
            this.dataList0 = res.data;
            this.loading = false;
          }
        });
      } else if (this.active === 2) {
        getReadJob(obj).then((res) => {
          if (res.code === 200) {
            this.dataList0 = res.data;
            this.loading = false;
          }
        });
      }
    },
  }
}
</script>

<style scoped>
.apply {
  width:100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.apply-top {
  background-color: rgb(248,248,248);
  padding-bottom: 10px;
}

.apply-body {
  flex: 1;
  overflow-y: scroll;
  padding-bottom: 20px;
}

.menu-detail {
  height: calc(100vh - 140px);
  display:flex;
}

.menu-list {
  width: auto;
  height: 100%;
}

/deep/ .van-hairline--bottom:after {
  border: none;
}

/deep/ .van-dropdown-menu__bar {
  box-shadow: none;
}

/deep/ .van-dropdown-menu__bar--opened {
  box-shadow: 0 2px 12px rgba(100, 101, 102, .12);
}

/deep/ .van-cascader__options {
  height: auto;
}
</style>